/* eslint-disable indent */
/* eslint-disable camelcase */
/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { history, connect } from 'umi';

import { get } from 'lodash';
import { getImgUrl, formatDate, appUrlJump, formatDateNew } from '@/utils/utils';
import { trackSensors } from '@/utils/sensors';
import useGCPI18n from '@/hooks/useGCPI18n';
import Header from '@/components/Header';
import { Clickable } from '@/components';
import HeaderProduct from '@/components/HeaderProduct';
import styles from './index.less';

const AwardsDetailNew = props => {
  const GCPI18n = useGCPI18n();
  const GameI18n = JSON.parse(window.localStorage.getItem('GAME_i18n'));
  const { myAwardsDetail = {}, getRewardMemDetailDXP, onClear, product } = props;
  const title = get(history, 'location.state.title') || GCPI18n({ id: 'lb_main_reward_details' });
  const specialTimeType = get(history, 'location.state.specialTimeType') || false;
  const fontFamily = get(history, 'location.state.fontFamily') || '';

  // const isRaffle = get(history, 'location.state.isRaffle');
  useEffect(() => {
    const { keyId, rewardInstanceId } = history.location.query;
    getRewardMemDetailDXP(rewardInstanceId || keyId);
    return () => onClear();
  }, []);

  useEffect(() => {
    if (myAwardsDetail.rewardId) {
      // 神策埋点
      trackSensors('ViewPrizeDetails', {
        prize_id: myAwardsDetail.rewardId,
        rewardId: myAwardsDetail.rewardId || '',
        prize_name: myAwardsDetail.rewardName,
      });
    }
  }, [myAwardsDetail.rewardId]);

  const handleUseIt = () => {
    if (myAwardsDetail?.appUrl) {
      appUrlJump(
        `${myAwardsDetail?.appUrl}?couponId=${myAwardsDetail?.couponId}&userCouponId=${myAwardsDetail?.couponInstId}&from=GCP`,
      );
    }
  };

  const renderRewardDetail = () => {
    const code = myAwardsDetail.prcResPwd;
    const serialNumber = myAwardsDetail.prcResSn;
    return (
      <>
        {code && (
          <div>
            <span>{GCPI18n({ id: 'lb_voucher_code' })}</span>
            <span className={styles.valid} style={{ color: '#0638a8' }}>
              {` ${code}`}
            </span>
          </div>
        )}
        {serialNumber && (
          <div>
            <span>{GCPI18n({ id: 'lb_main_serial_number' })}:</span>
            <span className={styles.valid} style={{ color: '#0638a8' }}>
              {` ${serialNumber}`}
            </span>
          </div>
        )}
      </>
    );
  };

  return (
    <div className={styles.page} style={{ fontFamily }}>
      {product === 'ESHOP' ? (
        <HeaderProduct title={title} />
      ) : (
        <Header
          title={title}
          titleColor="#3E3E3E"
          titleFontFamily={fontFamily}
          hideGoHome={specialTimeType}
        />
      )}
      <div className={styles.container}>
        <div className={styles.top}>
          <div className={styles.rewardImg}>
            <img src={getImgUrl(myAwardsDetail.serverUrl, myAwardsDetail.winningImageUrl)} alt="" />
          </div>
          <div className={styles.right}>
            <span className={styles.descirbe} style={{ fontFamily }}>
              {GameI18n[`rewardMem-${myAwardsDetail.rewardMemId}-rewardName`] ||
                myAwardsDetail.rewardName}
            </span>
            <div className={styles.validityBox}>
              {renderRewardDetail()}
              {['14', '15'].includes(`${myAwardsDetail.rewardType || ''}`) &&
                myAwardsDetail.validDays && (
                  <span className={styles.valiDate}>
                    {GCPI18n({ id: 'lb_main_validity_period' })}: {get(myAwardsDetail, 'validDays')}{' '}
                    {GCPI18n({ id: 'lb_main_validity_days' })}
                  </span>
                )}
              {['1', '8', '9', '14', '15', '23', '6'].includes(
                `${myAwardsDetail.rewardType || ''}`,
              ) &&
                myAwardsDetail.expDate && (
                  <span className={styles.valiDate}>
                    {GCPI18n({ id: 'lb_main_validity_date' })}:{' '}
                    {/* {formatDate(get(myAwardsDetail, 'expDate'), true)} */}
                    {!specialTimeType
                      ? formatDate(get(myAwardsDetail, 'expDate'), true)
                      : formatDateNew(get(myAwardsDetail, 'expDate'), true)}
                  </span>
                )}
            </div>
            {`${myAwardsDetail.rewardType}` === '23' && `${myAwardsDetail.state}` === 'B' && (
              <Clickable className={styles.useIt} onClick={() => handleUseIt()}>
                {GCPI18n({ id: 'lb_mian_use_it' })}
              </Clickable>
            )}
          </div>
        </div>
        <div className={styles.footer}>
          {/* <span className={styles.title}>{GCPI18n({ id: 'MAIN_REWARD_DETAILNEW' })}</span> */}
          <div className={styles.details}>
            <div
              dangerouslySetInnerHTML={{
                __html: myAwardsDetail.comments,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  getRewardMemDetailDXP: payload =>
    dispatch({
      type: 'myAwards/getRewardMemDetailDXP',
      payload,
    }),
  onClear: () =>
    dispatch({
      type: 'myAwards/save',
      payload: {
        myAwardsDetail: {},
      },
    }),
});

export default connect(
  ({ loading, myAwards, index }) => ({
    myAwardsDetail: myAwards.myAwardsDetail || {},
    loading: loading.effects['myAwards/getRewardMemDetailDXP'] || false,
    product: index.product,
    userDimension: index.userDimension,
  }),
  mapDispatchToProps,
)(AwardsDetailNew);
